import React, { Component } from "react";
import {
    BrowserRouter as Router,
    Route,
    Switch,
    Redirect
} from "react-router-dom";
import "./assets-import";

import PrivateRoute from "../Auth/PrivateRoute";
import LoginContainer from "../Auth/Login/LoginContainer";
import ForgotPasswordContainer from "../Auth/ForgotPassword/ForgotPasswordContainer";
import ResetPasswordContainer from "../Auth/ResetPassword/ResetPasswordContainer";
import Logout from "../Auth/Login/Logout";
import UserRoute from "../user/UserRoute";
import NotFound from "../Page/Error/NotFound";
import Dashboard from "../Dashboard";
// import OldDwk from '../OldDWK/OldDwkContainer'

class App extends Component {
    render() {
        return (
            <div className="App">
                <Router>
                    <Switch>
                        <Redirect from="/" exact to="/dashboard" />
                        {/* <Redirect from="/user/reset*" exact to="/newuser"/>users that received old DWK emails */}
                        <Redirect from="/user/reset*" exact to="/login" />
                        {/* users that received old DWK emails */}
                        {/* <Route path="/newuser" component={OldDwk}/> */}
                        <Route path="/login" component={LoginContainer} />
                        <Route path="/logout" component={Logout} />
                        <Route
                            path="/forgotpassword"
                            component={ForgotPasswordContainer}
                        />
                        <Route
                            path="/resetpassword/:token"
                            component={ResetPasswordContainer}
                        />
                        <PrivateRoute path="/dashboard" component={Dashboard} />
                        <PrivateRoute
                            path="/user/profile"
                            component={UserRoute}
                        />
                        <Route component={NotFound} />
                    </Switch>
                </Router>
            </div>
        );
    }
}

export default App;
